;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('inputTextRich', inputTextRich)

  /* @ngInject */
  function inputTextRich () {
    return {
      restrict: 'E',
      scope: {
        label: '@',
        description: '@',
        modelPropertyName: '@',
        model: '=?',
        value: '<',
        disabled: '<',
        change: '=',
        hideToolbar: '<',
        simpleToolbar: '<',
        readOnly: '<',
        mandatory: '<',
        placeholder: '@',
        addNgIfTrue: '<',
        maxLength: '<',
        buttons: '=',
        blur: '<',
        focus: '<',
        initializeAfterPromise: '<',
        annotationOptions: '=',
        showDescriptionTooltip: '<',
        descriptionTooltipText: '@'
      },
      templateUrl: '/core/directives/input-text-rich/input-text-rich-directive.html?$$REVISION$$',
      controller: 'InputTextRichController'
    }
  }
})()
